import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../../../../components/loading';

import {
  hideColumn,
  setDropdown,
} from '../../../../components/gsheet/format';

import ContinuePanel from '../../../../components/continue-panel';
import UpdateBtns from './update-btns';
import SubmitPanel from './submit-panel';

import updateData from './update-data';
import DialogPrompt from './dialog-prompt';

import loadFromLocalDB from '../hivdb/load-db';
import downloadWorkbook from '../../../../components/workbook/download';


import {
  PARENTSTRAINS,
  ALL_GENES,
} from '../../../../constants';


import {
  createGsheet,
  readGsheet,
  deleteGsheet,
  updateColumn,
  getColumnIndexName,
  updateColumnByColumn,
} from '../../../../components/gsheet';


export default class GsheetTable extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      showValidateDialog: false,
      showSubmit: false,
      loadGSheet: false,
      disableButtons: false,
      sheet: 'Mutations',
    };
  }

  set processing(value) {
    if (value) {
      this.setState({
        loadGSheet: true,
        disableButtons: true,
      });
    } else {
      this.setState({
        loadGSheet: false,
        disableButtons: false,
      });
    }
  }

  async componentDidMount() {
    await this.handleCreateGsheet();

    // window.addEventListener('beforeunload',
    //   this.handleDeleteGsheet(this.props.rawDataCollection.spreadsheet_id)
    // );
  }

  get header() {
    const {rawDataCollection} = this.props;
    const {seqType} = rawDataCollection;
    let header = null;

    if (seqType === 'ClinicalList') {
      if (rawDataCollection.hasRawSequences) {
        header  = this.clinical_header;
      } else {
        header = this.clinical_start_header;
      }
    } else {
      header = this.lab_header;
    }
    return header;
  }

  get clinical_start_header() {
    let header = [
      'Isolate Name',
      'Sequence ID',
      'Gene',
      'Mutations',
      'isCompleteMutationList',
    ];
    return header;
  }

  get clinical_header() {
    let header = [
      'Isolate Name',
      'Sequence ID',
      'Gene',
      'Mutations',
      'isCompleteMutationList',
    ];

    header = header.concat([
      'PtAlias',
      'Isolate Date',
      'Source',
      'Species',
      'Region',
      'Author subtype',
      'isChild',
    ]);
    return header;
  }

  get lab_header() {
    return [
      'Isolate Name',
      'Sequence ID',
      'Gene',
      'Mutations',
      'Parent Strain',
      'isSDM',
      'isUsingPassage',
    ];
  }

  get editable() {
    return [
    ];
  }

  get editableMap() {
    return [
    ];
  }

  get formats() {
    let result = [];

    const {rawDataCollection} = this.props;
    const {seqType} = rawDataCollection;

    if (seqType === 'ClinicalList') {
      result.push(
        setDropdown(
          this.header,
          "isCompleteMutationList",
          ['YES', 'NO'],
        )
      );
    } else {
      result.push(
        setDropdown(
          this.header,
          "Parent Strain",
          PARENTSTRAINS,
        )
      );
      result.push(
        setDropdown(
          this.header,
          "isSDM",
          ['Yes', 'No'],
        )
      );
      result.push(
        setDropdown(
          this.header,
          "isUsingPassage",
          ['Yes', 'No'],
        )
      );
    }

    result.push(
      setDropdown(
        this.header,
        'Gene',
        ALL_GENES,
      )
    );
    result.push(
      hideColumn(this.header, 'Sequence ID')
    );

    return result;
  }

  get table() {
    let table = [];

    const {rawDataCollection} = this.props;
    const {seqType} = rawDataCollection;
    const hasRawSequences = rawDataCollection.hasRawSequences;

    if (hasRawSequences && seqType === 'ClinicalList') {
      table = this.clinical_table;
    } else if (hasRawSequences && seqType === "LabList") {
      table = this.lab_table;
    } else {
      table.unshift(this.header);
    }
    return table;
  }

  get clinical_table() {
    const {rawDataCollection} = this.props;

    const {rawSequences} = rawDataCollection;

    let table = [];

    for (const seq of rawSequences) {
      const {seqType} = seq;
      if (seqType === 'Sequence') {
        continue;
      }
      let isCompleteMutationList = false;
      if (seqType === 'IncompleteSequence') {
        isCompleteMutationList = true;
      }
      const record = [
        seq.isolateName,
        seq.uuid,
        seq.gene,
        seq.mutations,
        isCompleteMutationList? 'YES': 'NO',
        seq.ptAlias,
        seq.isolateDate,
        seq.source,
        seq.species,
        seq.region,
        seq.authorSubtype,
        seq.isChild,
      ];
      table.push(record);
    }

    table.unshift(this.header);
    return table;
  }

  get lab_table() {
    const {rawDataCollection} = this.props;

    const {rawSequences} = rawDataCollection;

    let table = [];

    for (const seq of rawSequences) {
      const record = [
        seq.isolateName,
        seq.uuid,
        seq.gene,
        seq.mutations,
        seq.parent,
        seq.labSdm ? 'Yes': 'No',
        seq.labPassage
      ];
      table.push(record);
    }

    table.unshift(this.header);
    return table;
  }

  get title() {
    const {rawDataCollection: {references}} = this.props;
    const firstRef = references[0];
    const title = `${firstRef.author}. ` + (
      firstRef.medlineId ? `(PMID: ${firstRef.medlineId})`: ''
    );

    return title;
  }

  async handleCreateGsheet() {
    this.processing = true;

    const {table, formats, title} = this;
    const {sheet} = this.state;

    const {rawDataCollection, onUpdate} = this.props;

    let spreadsheet_id = rawDataCollection.spreadsheet_id;
    let file_info = await createGsheet(
      spreadsheet_id, title, sheet, table, formats);

    if ((
      rawDataCollection.spreadsheet_id != file_info.spreadsheet_id) || (
        rawDataCollection.sheet_id != file_info.sheet_id)) {
      rawDataCollection.spreadsheet_id = file_info.spreadsheet_id;
      rawDataCollection.sheet_id = file_info.sheet_id;
      onUpdate(rawDataCollection);
    }
    this.processing = false;
  }

  handleDeleteGsheet(spreadsheet_id) {
    if (!spreadsheet_id) {
      return null;
    }

    return async () => {
      await deleteGsheet(spreadsheet_id);
    };
  }

  async handleUpdateColumn(column_name, value) {
    this.processing = true;

    const {sheet} = this.state;
    if (column_name === 'PtAlias') {
      await updateColumnByColumn(
        this.props.rawDataCollection.spreadsheet_id,
        sheet,
        getColumnIndexName(this.header, column_name),
        getColumnIndexName(this.header, value),
      );
      return;
    }

    await updateColumn(
      this.props.rawDataCollection.spreadsheet_id,
      sheet,
      getColumnIndexName(this.header, column_name),
      value,
    );

    this.processing = false;
  }

  async handleUpdateMutations() {
    this.processing = true;

    let {rawDataCollection} = this.props;
    const {seqType} = rawDataCollection;
    const {sheet} = this.state;
    const {editableMap, header} = this;

    let rows = await readGsheet(
      this.props.rawDataCollection.spreadsheet_id, sheet);
    rawDataCollection = updateData(
      rawDataCollection, seqType, rows, header, editableMap);

    await this.handleCreateGsheet();

    const {onUpdate} = this.props;
    await onUpdate(rawDataCollection);

    this.processing = false;
  }

  async handleContinue() {

    this.processing = true;

    let {rawDataCollection} = this.props;
    const {seqType} = rawDataCollection;

    const {editableMap, header} = this;

    const {sheet} = this.state;
    let rows = await readGsheet(this.props.rawDataCollection.spreadsheet_id, sheet);
    rawDataCollection = updateData(
      rawDataCollection, seqType, rows, header, editableMap);

    rawDataCollection = await loadFromLocalDB(rawDataCollection);

    rawDataCollection.validate();
    if (rawDataCollection.messages('rawSequences').length > 0) {
      this.setState({
        showValidateDialog: true,
        showSubmit: false,
      });
    } else {
      this.setState({
        showValidateDialog: true,
        showSubmit: true,
      });
    }
    this.processing = false;
  }

  async handleSubmit() {
    this.processing = true;

    let {rawDataCollection} = this.props;
    const {onUpdate, onSubmit} = this.props;

    await onUpdate(rawDataCollection);

    onSubmit();
  }

  handleDownload() {
    this.processing = true;

    const {rawDataCollection} = this.props;

    downloadWorkbook(rawDataCollection);

    this.processing = false;
  }

  handleCloseDialog() {
    this.setState({
      showValidateDialog: false
    });
  }

  get submitNotContinue() {
    const {rawDataCollection} = this.props;

    const {seqType, rawSequences} = rawDataCollection;
    const showSubmitList = seqType && seqType === "ClinicalList" && rawSequences.length === 0;

    return showSubmitList;
  }

  get submitPanel() {
    if (this.submitNotContinue) {
      return (
        <SubmitPanel
         onUpdateMutations={this.handleUpdateMutations.bind(this)}
        />
      );
    } else {
      return null;
    }

  }

  get continuePanel() {
    if (this.submitNotContinue) {
      return null;
    }

    return (
      <ContinuePanel
       onSubmit={this.handleContinue.bind(this)}
       onDownload={this.handleDownload.bind(this)}
       disabled={this.state.disableButtons}
      />
    );
  }

  render() {
    const {rawDataCollection} = this.props;

    // if (!rawDataCollection.hasRawSequences) {
    //   return null;
    // }

    if (this.state.loadGSheet) {
      return <Loading />;
    }

    const incomplete = rawDataCollection.sequenceType === 'incomplete';

    return (
      <div>
        {rawDataCollection.hasRawSequences && !incomplete ? <div>
          <UpdateBtns
           rawDataCollection={rawDataCollection}
           onUpdateColumn={this.handleUpdateColumn.bind(this)}
           onSave={() => {}}
          />
          <hr/>
        </div> : null }

        <div>
          {this.submitPanel}
          {this.continuePanel}
          <DialogPrompt
           rawDataCollection={rawDataCollection}
           showDialog={this.state.showValidateDialog}
           showSubmit={this.state.showSubmit}
           onClose={
             this.handleCloseDialog.bind(this)}
           onSubmit={
             this.handleSubmit.bind(this)}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_mut/index.js